module.exports = __webpack_public_path__ + "img/leaflet4.321f6bb0.jpg";